<template>
  <div class="dice has-shadow" v-bind:class="{ empty: !number, keep: input && input.keep }" @click="$emit('clicked', $event)">
    <div class="eyes-wrapper">
      <div class="eyes">
        <!-- top row -->
        <span><span v-if="number == 2 || number == 3 || number == 4 || number == 5 || number == 6"></span></span>
        <span></span>
        <span><span v-if="number == 4 || number == 5 || number == 6"></span></span>

        <!-- middle row -->
        <span><span v-if="number == 6"></span></span>
        <span><span v-if="number == 1 || number == 3 || number == 5"></span></span>
        <span><span v-if="number == 6"></span></span>

        <!-- bottom row -->
        <span><span v-if="number == 4 || number == 5 || number == 6"></span></span>
        <span></span>
        <span><span v-if="number == 2 || number == 3 || number == 4 || number == 5 || number == 6"></span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dice',
  props: {
    input: Object
  },
  computed: {
    number () { 
      return this.input ? this.input.number : null;
    }
  }
};
</script>